<template>
  <footer class="bg-main_black text-white py-8">
    <div class="container mx-auto px-4">
      <!-- Logo & Navigation Links -->
      <div class="flex flex-col md:flex-row justify-between items-center mb-6 text-center md:text-left">
        <div class="flex items-center justify-center md:justify-start mb-4 md:mb-0">
          <img
            src="../assets/icons/hutu-abuja.png"
            :alt="getTranslation('footer.logoAlt', 'Hutu Abuja')"
            class="h-12"
          />
        </div>
        <div class="flex flex-wrap justify-center md:justify-end space-x-4 md:space-x-6">
          <div v-for="(link, index) in navigationLinks" :key="index">
            <span class="text-gray-500 hidden md:inline">•</span>
            <a
              href="#"
              @click.prevent="scrollToSection(link.key)"
              class="hover:text-gray-300 cursor-pointer"
            >
              {{ link.fallback }}
            </a>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-gray-800"></div>

      <!-- Copyright, Policies, and Social Links -->
      <div class="flex flex-col md:flex-row justify-between items-center mt-6 text-center md:text-left">
        <div class="mb-4 md:mb-0">
          © 2025. Hutu Abuja
        </div>
        <div class="flex flex-wrap justify-center md:justify-end space-x-4 md:space-x-6">
          <a href="#" class="hover:text-gray-300">
            {{ getTranslation('footer.policies.privacy', 'Privacy Policy') }}
          </a>
          <span class="text-gray-500 hidden md:inline">•</span>
          <a href="#" class="hover:text-gray-300">
            {{ getTranslation('footer.policies.terms', 'Terms and conditions') }}
          </a>
        </div>
        <!-- Instagram Links -->
        <div class="flex justify-center md:justify-end items-center space-x-4 mt-4 md:mt-0">
          <a
            href="https://www.instagram.com/aibenproperties_?igsh=MTh6bHhoZXFpNHRzOQ=="
            target="_blank"
            rel="noopener noreferrer"
            class="hover:text-gray-300 flex items-center gap-2"
            title="Aiben Properties"
          >
            <img
              src="../assets/icons/instagram.svg"
              alt="Aiben Properties Instagram"
              class="h-5"
            />
            <span class="text-sm text-gray-400 hidden sm:inline">@aibenproperties_</span>
          </a>
          <a
            href="https://www.instagram.com/mshelhutuexclusive_?igsh=bG84ZDJwb3VmbW84"
            target="_blank"
            rel="noopener noreferrer"
            class="hover:text-gray-300 flex items-center gap-2"
            title="Mshel Hutu Exclusive"
          >
            <img
              src="../assets/icons/instagram.svg"
              alt="Mshel Hutu Exclusive Instagram"
              class="h-5"
            />
            <span class="text-sm text-gray-400 hidden sm:inline">@mshelhutuexclusive_</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      navigationLinks: [
        { key: 'home', fallback: 'Home' },
        { key: 'services', fallback: 'Services' },
        { key: 'projects', fallback: 'Projects' },
        { key: 'about', fallback: 'About' }, 
      ]
    };
  },
  methods: {
    getTranslation(key, fallback) {
      try {
        // Check if $t function exists (i18n is available)
        if (this.$t && typeof this.$t === 'function') {
          const translation = this.$t(key);
          // If translation returns the key itself, it means translation is missing
          return translation !== key ? translation : fallback;
        }
        return fallback;
      } catch (error) {
        console.warn(`Translation error for key: ${key}`, error);
        return fallback;
      }
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        // Section exists on current page, scroll to it
        const navHeight = 80;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - navHeight,
          behavior: 'smooth'
        });
      } else {
        // Section doesn't exist, navigate to home page with hash
        this.$router.push({ path: '/', hash: `#${sectionId}` });
      }
    }
  }
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
